import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

type Props = {
  question: string;
  answer: string;
  isDark: boolean;
  defaultExpanded?: boolean;
};

export const FaqAccordionItem: React.FC<Props> = ({
  question,
  answer,
  isDark,
  defaultExpanded = false,
}) => {
  return (
    <Accordion
      defaultExpanded={defaultExpanded}
      slotProps={{ transition: { timeout: 200 } }}
      sx={{
        borderRadius: '32px!important',
        background: isDark ? 'rgba(26, 26, 26, 1)' : 'rgba(229, 229, 220, 1)',
        border: 0,
        boxShadow:
          '0px 0px 34.77px 0px #0000000D inset, 0px -0.5px 0.25px 0px #00000080 inset, 0px 0.5px 0.75px 0px #FFFFFF inset, 0px 2.07px 3.73px 0px #0000004D, 0px 2.08px 2.48px -2px #00000066, 0px 3.08px 2px -2px #00000054',
        p: 0,
        transition: 'background .2s',
        '&:before': { display: 'none' },
        '&:not(:last-child)': { marginBottom: '16px' },
        '&:hover': {
          background: isDark
            ? 'rgba(0, 92, 173, 0.2)'
            : 'rgba(209, 208, 198, 1)',
        },
        '&.Mui-expanded': {
          borderRadius: '32px 32px 0 0',
          boxShadow:
            '0px 0px 34.77px 0px #0000000D inset, 0px -0.5px 0.25px 0px #00000080 inset,0px 0.5px 0.75px 0px #FFFFFF inset,0px 2.07px 3.73px 0px #0000004D, 0px 2.08px 2.48px -2px #00000066, 0px 3.08px 2px -2px #00000054',
          background: isDark ? 'rgba(57, 57, 57, 1)' : '#D1D0C6',
        },
      }}
    >
      <AccordionSummary
        expandIcon={
          <ExpandMoreIcon sx={{ color: isDark ? '#FFFFFF' : '#1A1A1A' }} />
        }
        sx={{
          px: '24px',
          '& .MuiAccordionSummary-content': {
            my: { xs: '8px', sm: '12px' },
          },
          '&.Mui-expanded': {
            borderRadius: 0,
            boxShadow:
              '0px 0px 34.77px 0px #0000000D inset, 0px -0.5px 0.25px 0px #00000080 inset, 0px 0.5px 0.75px 0px #FFFFFF inset, 0px 2.07px 3.73px 0px #0000004D, 0px 2.08px 2.48px -2px #00000066, 0px 3.08px 2px -2px #00000054',
          },
          '&:hover': { background: 'none' },
        }}
      >
        <Typography
          sx={{
            fontFamily: 'Roboto, sans-serif',
            fontWeight: 700,
            fontSize: { xs: '14px', sm: '16px' },
            letterSpacing: { xs: '.1px', sm: '.15px' },
            lineHeight: { xs: '157%', sm: '175%' },
            color: isDark ? '#FFFFFF' : '#1A1A1A',
          }}
        >
          {question}
        </Typography>
      </AccordionSummary>

      <AccordionDetails
        sx={{
          background: isDark ? '#1A1A1A' : 'rgba(229, 229, 220, 1)',
          padding: { xs: '12px 24px 16px 24px', sm: '16px 24px 24px 24px' },
        }}
      >
        <Typography
          sx={{
            fontFamily: 'Roboto, sans-serif',
            fontSize: { xs: '14px', sm: '16px' },
            color: isDark ? '#B6B6B6' : '#393939',
            lineHeight: 1.6,
            whiteSpace: 'pre-line',
          }}
        >
          {answer}
        </Typography>
      </AccordionDetails>
    </Accordion>
  );
};
